import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MaterialIconComponent } from '../../../material-icon/material-icon.component';

@Component({
  selector: 'shared-core-warning-toast',
  imports: [MaterialIconComponent, NgOptimizedImage],
  templateUrl: './warning-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningToastComponent {
  readonly message = input.required<string>();

  closeToast = output();
}
